import { NavLink } from 'react-router-dom'
import { cn } from '../../lib/utils'
import type { SidebarNavSegment } from '../../config/sidebarNav'

function navLinkClass({ isActive }: { isActive: boolean }) {
  return cn(
    'relative flex w-full cursor-pointer items-center gap-3 rounded-lg py-2.5 pl-3 pr-2 text-sm font-medium transition-all duration-150',
    isActive
      ? 'bg-primary/15 text-foreground shadow-sm ring-1 ring-primary/20 before:absolute before:bottom-1.5 before:left-0 before:top-1.5 before:w-0.5 before:rounded-full before:bg-primary'
      : 'text-muted-foreground hover:bg-sidebar-accent/60 hover:text-foreground',
  )
}

type SidebarNavSectionsProps = {
  segments: SidebarNavSegment[]
  onNavigate?: () => void
}

export function SidebarNavSections({ segments, onNavigate }: SidebarNavSectionsProps) {
  return (
    <>
      {segments.map((segment, segmentIndex) => (
        <section
          key={segment.title ?? `segment-${segmentIndex}`}
          className={cn(segmentIndex > 0 && 'mt-5 border-t border-sidebar-border/50 pt-4')}
        >
          {segment.title ? (
            <p className="text-muted-foreground mb-2 px-3 text-[10px] font-semibold uppercase tracking-[0.14em]">
              {segment.title}
            </p>
          ) : null}
          <div className="flex flex-col gap-0.5">
            {segment.items.map((item) => {
              const Icon = item.icon
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  className={navLinkClass}
                  onClick={onNavigate}
                >
                  <Icon className="h-5 w-5 shrink-0" aria-hidden />
                  <span className="truncate">{item.label}</span>
                </NavLink>
              )
            })}
          </div>
        </section>
      ))}
    </>
  )
}
